import {useEffect, useMemo} from "react";
import {useSetState} from "ahooks";
import ReactECharts from 'echarts-for-react'
import {DatePicker, Spin, Radio, message, Tooltip, Collapse} from "antd";
import {SSegmentedTabs, STitle} from "shj-components";
import {isEmpty} from "lodash-es";
import dayjs from "dayjs";

import svg1 from '@/assets/measureChart1.svg'
import svg2 from '@/assets/measureChart2.svg'
import svg3 from '@/assets/measureChart3.svg'
import styles from './index.module.less'

export default function IncomingCallTrends(props) {

  const resultData = useMemo(() => {
    const data1 = [], data2 = [], data3 = [], data4 = [], dates = [];
    (props['call24HourChart'] || [])?.forEach(item => {
      data1.push(item['total'])
      data2.push(item['success'])
      data3.push(item['noAnswer'])
      data4.push(item['successRate'])
      dates.push(item['time'])
    })
    return {dates, data1, data2, data3, data4}
  }, [props])

    const option = {
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          return `
      <div style="border-radius: 5px; background: #FFF">
        <div style="color: #2D2D2E; margin-bottom: 5px">${params[0]?.name}</div>
        <div style="padding: 5px 10px; 
          width: 210px;
          background: #fff;
          box-shadow: 6px 0 20px 0 #2257BC1A; 
          margin-bottom: 5px; 
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center">
          <div style="display: flex; align-items: center">
            <div style="background: #0064FF; width: 8px; height: 8px; margin-right: 5px; border-radius: 10px"></div>
            <span style="color: #4E5969">呼出数据</span> 
          </div>
          <span style="color: #1D2129; font-weight: bolder">${params[0]?.value}</span>
        </div>
         <div style="padding: 5px 10px; 
          width: 210px;
          background: #fff;
          box-shadow: 6px 0 20px 0 #2257BC1A; 
          margin-bottom: 5px; 
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center">
          <div style="display: flex; align-items: center;;">
            <div style="background: #A6CEE3; width: 8px; height: 8px; margin-right: 5px; border-radius: 10px;"></div>
            <span style="color: #4E5969">呼出接通</span> 
          </div>
          <span style="color: #1D2129; font-weight: bolder">${params[1]?.value}</span>
        </div>
        <div style="padding: 5px 10px; 
          width: 210px;
          background: #fff;
          box-shadow: 6px 0 20px 0 #2257BC1A; 
          margin-bottom: 5px; 
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center">
          <div style="display: flex; align-items: center;;">
            <div style="background: #A6CEE3; width: 8px; height: 8px; margin-right: 5px; border-radius: 10px;"></div>
            <span style="color: #4E5969">呼出未接</span> 
          </div>
          <span style="color: #1D2129; font-weight: bolder">${params[2]?.value}</span>
        </div>
        <div style="padding: 5px 10px; 
          width: 210px;
          background: #fff;
          box-shadow: 6px 0 20px 0 #2257BC1A; 
          margin-bottom: 5px; 
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center">
          <div style="display: flex; align-items: center;;">
            <div style="background: #A6CEE3; width: 8px; height: 8px; margin-right: 5px; border-radius: 10px;"></div>
            <span style="color: #4E5969">外呼接通率</span> 
          </div>
          <span style="color: #1D2129; font-weight: bolder">${params[3]?.value}%</span>
        </div>
      </div>
    `;
        },
        padding: 10,
      },
      legend: {
        bottom: 0,
        icon: 'circle', // 修改图标形状为矩形（原为默认圆形）
        itemHeight: 8,
        itemGap: 20,
        selectorButtonGap: 5,
        itemStyle: {
          padding: 0
        },
        textStyle: {
          fontSize: 14,
        }
      },
      grid: {
        left: 15,
        right: 15,
        bottom: 30,
        containLabel: true,
        lineStyle: {
          color: '#eee',       // 网格线颜色
          width: 1,            // 线宽
          type: 'dashed',      // 虚线类型
          opacity: 0.8         // 透明度
        }
      },
      xAxis: [
        {
          type: 'category',
          data: resultData.dates,
          axisPointer: {
            lineStyle: {
              color: '#4080FF',
              width: 2,
            }
          },
          splitLine: {
            show: true
          }
        },
      ],
      yAxis: [
        {
          type: 'value',
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value}',
            color: '#666'
          },
        },
      ],
      series: [
        {
          name: `呼出数据`,
          type: 'line',
          smooth: true,
          symbolSize: 8,
          symbol: 'circle',
           itemStyle: {
            color: '#0064FF',
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1, // 渐变方向（从上到下）
              colorStops: [
                {offset: 0, color: 'rgba(0, 100, 255, 0.3)'}, // 顶部颜色
                {offset: 1, color: 'rgba(0, 100, 255, 0)'}  // 底部颜色
              ]
            }
          },
          emphasis: {
            focus: 'series',
            blurScope: 'coordinateSystem',
            itemStyle: {
              color: '#fff', // 悬停时颜色
              borderColor: '#4080FF', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
          },
          data: resultData.data1
        },
        {
          name: `呼出接通`,
          type: 'line',
          smooth: true,
          symbolSize: 8,
          symbol: 'circle',
          itemStyle: {
            color: '#028F60',
          },
          emphasis: {
            focus: 'series',
            blurScope: 'coordinateSystem',
            itemStyle: {
              color: '#fff', // 悬停时颜色
              borderColor: '#028F60', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
          },
          data: resultData.data2
        },
        {
          name: `呼出未接`,
          type: 'line',
          smooth: true,
          symbolSize: 8,
          symbol: 'circle',
          itemStyle: {
            color: '#F59300',
          },
          emphasis: {
            focus: 'series',
            blurScope: 'coordinateSystem',
            itemStyle: {
              color: '#fff', // 悬停时颜色
              borderColor: '#F59300', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
          },
          data: resultData.data3
        },
        {
          name: `外呼接通率`,
          type: 'line',
          smooth: true,
          symbolSize: 8,
          symbol: 'circle',
          itemStyle: {
            color: '#E03522',
          },
          emphasis: {
            focus: 'series',
            blurScope: 'coordinateSystem',
            itemStyle: {
              color: '#fff', // 悬停时颜色
              borderColor: '#E03522', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
          },
          data: resultData.data4
        },
      ]
    };

    return (
        <div>
          <div className={styles.wrapBox} style={{marginBottom: 10}}>
            <STitle title={'24h呼出数据趋势'}/>
            <div className={styles.chartBox}>
              <ReactECharts option={option}/>
            </div>
          </div>
        </div>
    );
  }
